<template>
  <div class="toolbar flex align-center justify-space-between">
    <div class="box-left box grow flex">
      <h1>{{pageTitle}}</h1>
    </div>
    <div class="box-right flex align-center pl-10">
      <span class="username">
        <span>{{userProfile.firstname}}</span>
      </span>
      <el-dropdown
        trigger="click"
        @command="onCommand"
        v-for="(headerNav, idx) in topNav"
        :key="idx"
        :index="idx.toString()"
      >
        <span class="el-dropdown-link">
          <i class="material-icons avatar">{{headerNav.icon}}</i>
        </span>
        <el-dropdown-menu slot="dropdown" v-if="headerNav.submenu">
          <el-dropdown-item
            command="/admin/account"
            v-for="(submenu, idx) in headerNav.submenu"
            :key="idx"
            :index="idx.toString()"
          >
            <i class="mdi material-icons mr-10">{{submenu.icon}}</i>
            {{submenu.title}}
          </el-dropdown-item>
          <el-dropdown-item command="/logout">
            <i class="mdi material-icons mr-10">exit_to_app</i>
            Logout
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>

<script>
// import NotificationBox from "@/components/NotificationBox";
// import Search from "@/components/Search";
import { mapGetters } from "vuex";
import { TopNavigation } from "@/json/navigation_json.js";

export default {
  name: "Toolbar",
  props: ["pageTitle"],
  data() {
    return {
      topNav: TopNavigation.data,
      popoverWidth: 300,
      fullscreen: false,
      lang: "us"
    };
  },
  methods: {
    onCommandLang(lang) {
      if (lang.charAt(0) === "/") this.onCommand(lang);
      else this.lang = lang;
    },
    onCommand(path) {
      this.$router.push(path);
    },
    toggleSidebar() {
      this.$emit("toggle-sidebar");
    },
    resizePopoverWidth() {
      if (window.innerWidth <= 768) {
        this.popoverWidth = 250;
      } else {
        this.popoverWidth = 300;
      }
    },
    toggleFullscreen() {
      this.$fullscreen.toggle(document.querySelector("body"), {
        wrap: false,
        callback: () => {
          this.fullscreen = this.$fullscreen.getState();
        }
      });
    }
  },
  computed: {
    ...mapGetters(["userProfile"])
  },
  components: {},
  mounted() {
    // this.fullscreen = this.$fullscreen.getState();
    this.resizePopoverWidth();
    window.addEventListener("resize", this.resizePopoverWidth);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.resizePopoverWidth);
  }
};
</script>

<style scoped>
@import "assets/styles/_variables.css";

.toolbar {
  width: 100%;
  height: 100%;
  padding: 0 20px;
  box-sizing: border-box;

  .username {
    margin-left: 20px;
    font-weight: bold;
    text-shadow: 0px 0px 1px lighten(var(--background-color), 0%),
      0px 0px 1px lighten(var(--background-color), 0%),
      0px 0px 1px lighten(var(--background-color), 0%),
      0px 0px 1px lighten(var(--background-color), 0%),
      0px 0px 1px lighten(var(--background-color), 0%),
      0px 0px 1px lighten(var(--background-color), 0%),
      0px 0px 1px lighten(var(--background-color), 0%),
      0px 1px 2px rgba(0, 0, 0, 0.3), 0px 3px 9px rgba(0, 0, 0, 0.1);

    a {
      color: var(--text-color);
      text-decoration: none;

      &:hover {
        color: var(--text-color-accent);
      }
    }
  }

  .avatar {
    border-radius: 50%;
    width: 35px;
    height: 35px;
    border: 1px solid #fff;
    margin-left: 20px;
    box-sizing: border-box;
    display: block;
    cursor: pointer;
    box-shadow: 0 2px 5px 0 rgba(49, 49, 93, 0.1),
      0 1px 2px 0 rgba(0, 0, 0, 0.08);
    transition: box-shadow 0.5s;
    font-size: 35px;
    &:hover {
      box-shadow: 0px 3px 10px 0 rgba(49, 49, 93, 0.08),
        0px 2px 7px 0 rgba(0, 0, 0, 0.08);
    }
  }

  .notification-icon {
    font-size: 20px;
    outline: none;
    padding: 0;
    background: transparent;
    border: none;
    margin-left: 20px;
    /* color: #aab7c5; */
    color: transparentize(var(--text-color), 0.7);
    text-shadow: 0px 0px 1px lighten(var(--background-color), 0%),
      0px 0px 1px lighten(var(--background-color), 0%),
      0px 0px 1px lighten(var(--background-color), 0%),
      0px 0px 1px lighten(var(--background-color), 0%),
      0px 0px 1px lighten(var(--background-color), 0%),
      0px 0px 1px lighten(var(--background-color), 0%),
      0px 0px 1px lighten(var(--background-color), 0%),
      0px 1px 2px rgba(0, 0, 0, 0.3), 0px 3px 9px rgba(0, 0, 0, 0.1);

    &:hover {
      color: var(--text-color-accent);
    }
  }

  .toggle-sidebar {
    border: 1px solid transparent;
    height: 32px;
    min-height: 32px;
    line-height: 32px;
    width: 32px;
    min-width: 32px;
    max-width: 32px;
    box-sizing: border-box;
    text-align: center;
    margin: 0;
    outline: none;
    margin-right: 5px;
    font-size: 24px;
    padding: 0;
    cursor: pointer;
    display: inline-block;
    color: var(--text-color);
    background: white;
    display: none;
    opacity: 0;
    transition: all 0.5s;

    &__right {
      margin-right: 0px;
      margin-left: 5px;
    }

    &:hover,
    &:focus,
    &:active {
      color: var(--text-color-accent);
      border-color: var(--text-color-accent);
    }
  }

  .fullscreen-button {
    font-size: 24px;
    cursor: pointer;
    outline: none;
    padding: 0;
    background: transparent;
    border: none;
    margin-left: 20px;
    /* color: #aab7c5; */
    color: transparentize(var(--text-color), 0.7);
    text-shadow: 0px 0px 1px lighten(var(--background-color), 0%),
      0px 0px 1px lighten(var(--background-color), 0%),
      0px 0px 1px lighten(var(--background-color), 0%),
      0px 0px 1px lighten(var(--background-color), 0%),
      0px 0px 1px lighten(var(--background-color), 0%),
      0px 0px 1px lighten(var(--background-color), 0%),
      0px 0px 1px lighten(var(--background-color), 0%),
      0px 1px 2px rgba(0, 0, 0, 0.3), 0px 3px 9px rgba(0, 0, 0, 0.1);

    &:hover {
      color: var(--text-color-accent);
    }
  }

  .el-dropdown {
    .flag-icon {
      box-shadow: 0 2px 5px 0 rgba(49, 49, 93, 0.1),
        0 1px 2px 0 rgba(0, 0, 0, 0.08);
      cursor: pointer;
      border: 1px solid lighten(var(--background-color), 20%);
      background-color: lighten(var(--background-color), 20%);
    }
  }
}

@media (max-width: 650px) {
  .toolbar {
    .username {
      display: none;
    }
  }
}

@media (max-width: 768px) {
  .toolbar {
    padding: 0 10px;

    .toggle-sidebar {
      display: block;
      opacity: 1;
    }

    .fullscreen-button {
      display: none;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/layout/Toolbar.vue